import * as fx from '../audio/fx';
import * as engine from '../app/engine';
import { app, on } from '../app/state';
import { PRESETS } from '../core/constants';
import type { PresetKey } from '../core/types';
import { $, $$ } from './dom';
import { toast } from './toast';

export function currentPreset(): PresetKey | 'custom' {
  const { focus, short, long } = app.data.settings;
  for (const [k, p] of Object.entries(PRESETS))
    if (p.focus === focus && p.short === short && p.long === long) return k as PresetKey;
  return 'custom';
}

function render() {
  const cur = currentPreset();
  for (const b of $$('.preset')) {
    const on = b.dataset.p === cur;
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', String(on));
  }
  const s = app.data.settings;
  $('#customLabel').textContent = `${s.focus}·${s.short}·${s.long}`;
}

export function initPresets(openSettings: () => void) {
  let armed: string | null = null;
  let armTimer: ReturnType<typeof setTimeout> | undefined;
  $('#presetsRow').addEventListener('click', (e) => {
    const b = (e.target as Element).closest<HTMLElement>('.preset');
    if (!b) return;
    fx.tap();
    const key = b.dataset.p as PresetKey | 'custom';
    if (key === 'custom') return openSettings();
    if (key === currentPreset()) return;
    const force = armed === key;
    if (!engine.applyPreset(key, force)) {
      // A session is in progress: require a second tap so progress is never lost by accident.
      armed = key;
      clearTimeout(armTimer);
      armTimer = setTimeout(() => (armed = null), 3000);
      toast(`Session in progress — tap ${PRESETS[key].name} again to switch`, 'var(--tomato)');
      return;
    }
    armed = null;
    const p = PRESETS[key];
    toast(`${p.name} rhythm — ${p.focus}·${p.short}·${p.long}`);
  });
  on('settings', render);
  render();
}
